import React, { useEffect, useState } from "react";
import axios from "axios";
import InputOption from "../../../component/InputOption/InputOption"

const ProductComponent = ({ type, onProductUpdated, onSubtotalUpdated, onProductDiscount, items }) => {
    const [optionProduct, setOptionProduct] = useState([]);
    const [optionTax, setOptionTax] = useState([]);

    const [rows, setRows] = useState([
        {
            product: "",
            description: "",
            quantity: 1,
            unit: "Trip",
            unit_price: 0,
            discount: 0,
            tax: 0,
            tax_id: "",
            tax_name: ""
        },
    ]);

    const [error, setError] = useState(null);

    const handleChange = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const addRow = () => {
        setRows([
            ...rows,
            {
                product: "",
                description: "",
                quantity: 1,
                unit: "Unit",
                unit_price: 0,
                discount: 0,
                tax: 0,
            },
        ]);
    };

    const removeRow = (index) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);
    };

    const calculateRowTotal = (row) => {
        return row.unit_price * row.quantity;
    };

    const calculateRowDiscount = (row) => {
        const discountAmount = (row.unit_price * row.quantity * row.discount) / 100;
        return discountAmount;
    };

    const calculateRowTax = (row) => {
        const discountAmount = (row.unit_price * row.quantity * row.discount) / 100;
        const taxAmount =
            ((row.unit_price * row.quantity - discountAmount) * row.tax) / 100;
        return taxAmount;
    };

    const calculateSubtotal = (type) => {
        if (type == 'amount') {
            return rows.reduce((total, row) => total + calculateRowTotal(row), 0);
        } else if (type == 'discount') {
            return rows.reduce((total, row) => total + calculateRowDiscount(row), 0);
        } else if (type == 'tax') {
            return rows.reduce((total, row) => total + calculateRowTax(row), 0);
        }
        return 0;
    };

    const BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const PATH_PRODUCT_SALE = "api/erpppsu/product/optionsale";
    const PATH_PRODUCT_PURCHASE = "api/erpppsu/product/optionpurchase";
    const PATH_TAX = "api/erpppsu/product/optiontaxes";

    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response.data; // Return only the data from the response
        } catch (err) {
            setError("Failed to fetch data. Please try again later.");
            console.log(err);
        } finally {
            // setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(`${BASE_URL}${PATH_TAX}`).then((data) => {
            setOptionTax(data);
        });
    }, []);

    useEffect(() => {
        onProductUpdated(rows);
        onSubtotalUpdated(calculateSubtotal('amount'));
        onProductDiscount(calculateSubtotal('discount'));
    }, [rows])

    useEffect(() => {
        if (items && items.length > 0) {
            const formattedRows = items.map((item) => ({
                product: item.product,
                description: item.description,
                quantity: parseInt(item.quantity),
                unit: item.unit,
                unit_price: parseFloat(item.unit_price),
                discount: parseFloat(item.discount),
                tax: parseFloat(item.tax),
                tax_id: item.tax_id,
                tax_name: item.tax_name,
            }));
            setRows(formattedRows);
        }
    }, [items]);

    useEffect(() => {
        if (type == 'purchase') {
            fetchData(`${BASE_URL}${PATH_PRODUCT_PURCHASE}`).then((data) => {
                setOptionProduct(data);
            });
        } else if (type == 'sale') {
            fetchData(`${BASE_URL}${PATH_PRODUCT_SALE}`).then((data) => {
                setOptionProduct(data);
            });
        }
    }, [type])

    return (
        <div className="p-4 relative">
            <div className="max-w-md md:min-w-[640px] md:max-w-screen-lg lg:max-w-screen-xl overflow-x-auto">
                <table className="w-full border-collapse border border-gray-200">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="min-w-40 p-2 border border-gray-200">Produk</th>
                            <th className="min-w-40 p-2 border border-gray-200">Deskripsi</th>
                            <th className="min-w-25 p-2 border border-gray-200">Kuantitas</th>
                            <th className="p-2 border border-gray-200">Unit</th>
                            <th className="min-w-40 p-2 border border-gray-200">Harga Satuan</th>
                            <th className="min-w-40 p-2 border border-gray-200">Diskon (%)</th>
                            <th className="min-w-40 p-2 border border-gray-200">Pajak (%)</th>
                            <th className="min-w-40 p-2 border border-gray-200">Jumlah</th>
                            <th className="p-2 border border-gray-200"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row, index) => (
                            <tr key={index}>
                                <td className="p-2 border border-gray-200">                                    
                                    <InputOption
                                        label="Pilih Produk"
                                        data={optionProduct}
                                        placeholder="Ketik disini"
                                        defaultValue={row?.product}
                                        onChange={(value) => {
                                            handleChange(index, "product", value)
                                            const product = optionProduct.find(item => item.id === value);
                                            handleChange(index, "description", product?.description);
                                            handleChange(index, "unit", product?.unit);
                                            if (type == 'purchase') {
                                                handleChange(index, "unit_price", parseFloat(product?.price_buy ?? 0))
                                            } else if (type == 'sale') {
                                                handleChange(index, "unit_price", parseFloat(product?.price_sell ?? 0))
                                            }
                                        }}
                                        />
                                </td>
                                <td className="p-2 border border-gray-200">
                                    <input
                                        type="text"
                                        className="w-full border border-gray-300 rounded-md p-2"
                                        value={row.description}
                                        onChange={(e) =>
                                            handleChange(index, "description", e.target.value)
                                        }
                                        placeholder="Masukkan keterangan"
                                    />
                                </td>
                                <td className="p-2 border border-gray-200">
                                    <input
                                        type="number"
                                        className="w-full border border-gray-300 rounded-md p-2"
                                        value={row.quantity}
                                        onChange={(e) =>
                                            handleChange(index, "quantity", parseInt(e.target.value))
                                        }
                                        min="1"
                                    />
                                </td>
                                <td className="p-2 border border-gray-200">
                                    <p>{row.unit}</p>
                                    {/* <select
                                        className="w-full border border-gray-300 rounded-md p-2"
                                        value={row.unit}
                                        onChange={(e) =>
                                            handleChange(index, "unit", e.target.value)
                                        }
                                    >
                                        <option value="Trip">Trip</option>
                                        <option value="Buah">Buah</option>
                                    </select> */}
                                </td>
                                <td className="p-2 border border-gray-200">
                                    <input
                                        type="text"
                                        className="w-full border border-gray-300 rounded-md p-2"
                                        value={row.unit_price}
                                        onChange={(e) =>
                                            handleChange(index, "unit_price", e.target.value)
                                        }
                                        min="0"
                                    />
                                </td>
                                <td className="p-2 border border-gray-200">
                                    <input
                                        type="number"
                                        className="w-full border border-gray-300 rounded-md p-2"
                                        value={row.discount}
                                        onChange={(e) =>
                                            handleChange(index, "discount", parseFloat(e.target.value))
                                        }
                                        min="0"
                                        max="100"
                                    />
                                </td>
                                <td className="p-2 border border-gray-200">
                                    <select
                                        className="w-full border border-gray-300 rounded-md p-2"
                                        value={row.tax_id}
                                        onChange={(e) => {
                                            const tax = optionTax.find(item => item.id === e.target.value);
                                            if (tax) {
                                                handleChange(index, "tax_id", tax.id);
                                                handleChange(index, "tax_name", tax.name);
                                                handleChange(index, "tax", parseInt(tax.rate));
                                            } else {
                                                handleChange(index, "tax_id", null);
                                                handleChange(index, "tax_name", "-");
                                                handleChange(index, "tax", 0);
                                            }
                                        }}
                                    >
                                        <option value="">Pilih Pajak</option>
                                        {optionTax.map((tax) => (
                                            <option key={tax.id} value={tax.id}>
                                                {tax.name}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                                <td className="p-2 border border-gray-200">
                                    Rp {calculateRowTotal(row).toLocaleString("id-ID", {
                                        minimumFractionDigits: 2,
                                    })}
                                </td>
                                <td className="p-2 border border-gray-200 text-center">
                                    <button
                                        onClick={() => removeRow(index)}
                                        className="text-red-500 hover:text-red-700"
                                    >
                                        &times;
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <button
                type="button"
                onClick={addRow}
                className="mt-4 px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
            >
                Tambah Produk
            </button>
        </div>
    );
};

export default ProductComponent;
